import { useApiClient } from "@/composables/useApiClient";
import { useSession } from "@/composables/useSession";

export function useIncognito() {
  const userStore = useUserStore();
  const incognitoStore = useIncognitoStore();

  const queryClient = useQueryClient();

  const { refetchUser } = useSession();

  const { sessions: sessionsService } = useApiClient();

  const route = useRoute();

  const loginAs = async (userId: string) => {
    incognitoStore.path = route.fullPath;

    try {
      await sessionsService.enterIncognito({
        toolsUserId: userId,
      });

      userStore.reset();

      queryClient.clear();

      await refetchUser();
    } catch (error) {
      incognitoStore.$reset();
      console.error(error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await sessionsService.exitIncognitoMode();

      userStore.reset();
      incognitoStore.$reset();

      queryClient.clear();

      await refetchUser();
    } catch (error) {
      console.error(error);
    }
  };

  return {
    loginAs,
    logout,
  };
}
